import { computed, ref } from 'vue'
import includes from 'lodash/includes'

const useSharedGroups = () => {
  const sharedGroups = ref(['me'])
  const sharedGroupsForm = computed({
    get () {
      const res = {
        shared: false,
        hash_shared_to_group_ids: null
      }

      if (!includes(sharedGroups.value, 'me')) {
        res.shared = true

        if (!includes(sharedGroups.value, 'all')) {
          res.hash_shared_to_group_ids = sharedGroups.value
        }
      }

      return res
    },

    set (newVal) {
      if (newVal.shared) {
        if (newVal.hash_shared_to_group_ids) {
          sharedGroups.value = newVal.hash_shared_to_group_ids
          return
        }

        sharedGroups.value = ['all']
        return
      }

      sharedGroups.value = ['me']
    }
  })

  return {
    sharedGroups,
    sharedGroupsForm
  }
}

export default useSharedGroups
